import { workflowsSettingRegistrations } from '../settings/workflows-setting-definitions.js';
import { workflowsModuleManifest } from '../workflows.module.js';
export const workflowsWebModuleContribution = {
    moduleId: 'workflows',
    manifest: workflowsModuleManifest,
    settingRegistrations: workflowsSettingRegistrations,
    settingEditors: [],
    hostContracts: [],
    hostContributions: [],
    routes: [{
            id: 'workflows.web.rules',
            moduleId: 'workflows',
            path: '/workflows/rules',
            requiredPermission: 'workflows.rules.read',
            navigation: {
                id: 'workflows.navigation.rules',
                fallbackLabel: 'Workflows',
                labelConfigurationKey: 'workflows.copy.rules',
                labelValueProperty: 'navigationLabel',
                priority: 70,
            },
            load: () => import('./workflows-rules.page.js'),
        }],
};
export default workflowsWebModuleContribution;
//# sourceMappingURL=workflows-web.module-contribution.js.map